import { labelDayButton } from 'react-day-picker';

// The dot row marking a day with sessions is `aria-hidden`, so a screen reader needs the
// information folded into the day's own name instead.
export function getDayButtonLabel(...args: Parameters<typeof labelDayButton>): string {
    const [, modifiers] = args;
    const label = labelDayButton(...args);
    return modifiers.marked ? `${label}, has sessions` : label;
}
